module.exports = __webpack_public_path__ + "9768f8ce8883298edf5872152fc9366c.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./docs/karte_festival.jpg
// module id = 455
// module chunks = 0